export enum AppUserTypes {
  InternalUsers = 'InternalUsers',
  Customers = 'Customers',
  SubCustomers = 'SubCustomers',
}
